/**
 * 基础项目资料详情
 * /api/customer/baseProjectData/v1/queryById
 */

/**
 * @author yyl
 * 功能：查询公司信息
 */

import { Service } from '@/tools'

export class BaseProjectDataService<T extends TCustomer.BaseProjectData> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCustomer.BaseProjectData}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  //基础项目资料详情（id）
  // /api/customer/baseProjectData/v1/queryById
  queryById = <K extends T['ApiQueryById']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryById', data)

  //分页查询基础项目资料
  // /api/customer/baseProjectData/v1/page
  page = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)

  //更新基础项目资料
  // /api/customer/baseProjectData/v1/edit
  edit = <K extends T['ApiEdit']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiEdit', data)

  //新增基础项目资料
  // /api/customer/baseProjectData/v1/add
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data)
}
